// extracted by mini-css-extract-plugin
module.exports = {"marketTableBody":"Market_marketTableBody_3_HCF","cardTitle":"Market_cardTitle_36fZA"};